import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';
import { DimensionsSelectionModel } from 'src/app/shared/import/dimensions-selection-model';

@Component({
  templateUrl: './dimensions-columns-selection.component.html',
  styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class DimensionsColumnsSelectComponent extends BaseColumnSelectComponent implements OnInit {
    projectId: string;
    public benchmarksAvailable: boolean = false;

    loading = true;

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute,
        private router: Router, private projectService: ProjectService, private importProgressService: ImportProgressService)
    {
        super();
    }

    public toggleSelect(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        column.isSelected = !column.isSelected;
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if(projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.dataService.get<DimensionsSelectionModel>('columnSelection/dimensions/' + projectId)
                    .then(resp => {
                        this.columns = resp.columns;
                        this.benchmarksAvailable = resp.benchmarksAvailable;
                        this.loading = false;
                    });
            }
        });
    }

    async save(wantBenchmarks: boolean) {
        if (this.loading) {
            return;
        }

        try {
            this.loading = true;
            let selectedColumns = [];
            for (let i = 0; i < this.columns.length; ++i) {
                if(this.columns[i].isSelected) {
                    selectedColumns.push(i);
                }
            }
            await this.dataService.post('columnSelection/dimensions', {
                projectId: this.projectId,
                selectedColumns: selectedColumns,
            });
            if (wantBenchmarks) {
                this.importProgressService.setImportStep(ImportStep.series);
            } else {
                this.importProgressService.setImportStep(ImportStep.dimensions);
            }
            this.router.navigateByUrl(`/complexity-mgnt?projectId=${this.projectId}&benchmarks=${wantBenchmarks}`);
        } finally {
            this.loading = false;
        }
    }
    
}
